import { createContext, useContext } from 'react';

export type ProfileManagerLauncherValue = {
  openEditProfile: (profileId: number) => void;
  openEditGroup: (groupId: number) => void;
};

export const ProfileManagerLauncherContext = createContext<ProfileManagerLauncherValue | null>(null);

export function useProfileManagerLauncher(): ProfileManagerLauncherValue | null {
  return useContext(ProfileManagerLauncherContext);
}
